import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { IMAGES } from '../data/content';

const IK = 'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/gallery';

const galleryItems = [
  { type: 'image', src: `${IK}/gallery1.webp` },
  { type: 'image', src: `${IK}/gallery2.webp` },
  { type: 'image', src: `${IK}/gallery3.webp` },
  { type: 'video', src: `${IK}/gallery4.mp4`, poster: `${IK}/gallery1.webp` },
  { type: 'video', src: `${IK}/gallery5.mp4`, poster: `${IK}/gallery2.webp` },
  { type: 'video', src: `${IK}/gallery6.mp4`, poster: `${IK}/gallery3.webp` },
];

export default function Gallery() {
  const [lightboxIdx, setLightboxIdx] = useState(null);

  const prev = () => setLightboxIdx(p => (p - 1 + galleryItems.length) % galleryItems.length);
  const next = () => setLightboxIdx(p => (p + 1) % galleryItems.length);
  const current = lightboxIdx !== null ? galleryItems[lightboxIdx] : null;

  return (
    <div style={{ background: '#1E1108', paddingTop: '68px', minHeight: '100vh' }}>
      <Helmet>
        <title>Gallery | Vaidyam Ayurveda Bhopal</title>
        <meta name="description" content="Gallery of authentic Kerala Ayurveda therapies at Vaidyam Ayurveda Bhopal by Dr. Monika Jain." />
      </Helmet>

      {/* Hero */}
      <div style={{ position: 'relative', height: '320px', overflow: 'hidden' }}>
        <img src="https://ik.imagekit.io/gnzsnmo3fr/vaidyam/hero/galleryhero.webp" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.3)' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, #1E1108, transparent 60%)' }} />
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'flex-end', padding: '0 48px 48px' }}>
          <div style={{ maxWidth: '1280px', margin: '0 auto', width: '100%' }}>
            <span style={{ fontSize: '10px', letterSpacing: '3px', color: '#C8941A', textTransform: 'uppercase', fontWeight: 500, display: 'block', marginBottom: '12px' }}>Gallery</span>
            <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '56px', color: '#F0E6D8' }}>A Glimpse of Vaidyam</h1>
          </div>
        </div>
      </div>

      {/* Grid — 3 columns */}
      <div style={{ padding: '40px 48px 100px' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '4px' }}>
          {galleryItems.map((item, i) => (
            <div key={i}
              style={{ height: '300px', overflow: 'hidden', cursor: 'pointer', position: 'relative', background: '#261408' }}
              onClick={() => setLightboxIdx(i)}
            >
              {item.type === 'video' ? (
                <>
                  <video src={item.src} style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.85)' }} muted playsInline />
                  <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.25)' }}>
                    <div style={{ width: '52px', height: '52px', borderRadius: '50%', background: 'rgba(200,148,26,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                    </div>
                  </div>
                </>
              ) : (
                <img src={item.src} alt="Vaidyam Ayurveda"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' }}
                  onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
                  onMouseLeave={e => e.target.style.transform = 'scale(1)'}
                />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightboxIdx !== null && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(8,4,2,0.96)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}
          onClick={() => setLightboxIdx(null)}
        >
          <button onClick={e => { e.stopPropagation(); prev(); }}
            style={{ position: 'absolute', left: '24px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', color: '#F0E6D8', borderRadius: '3px', width: '48px', height: '48px', fontSize: '22px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>‹</button>

          <div style={{ maxWidth: '85vw', maxHeight: '85vh' }} onClick={e => e.stopPropagation()}>
            {current?.type === 'video' ? (
              <video src={current.src} controls autoPlay style={{ maxWidth: '100%', maxHeight: '85vh', borderRadius: '3px' }} />
            ) : (
              <img src={current?.src} alt="Vaidyam" style={{ maxWidth: '100%', maxHeight: '85vh', objectFit: 'contain', borderRadius: '3px' }} />
            )}
            <div style={{ textAlign: 'center', marginTop: '14px', fontSize: '12px', color: 'rgba(240,230,216,0.3)', letterSpacing: '2px' }}>
              {lightboxIdx + 1} / {galleryItems.length}
            </div>
          </div>

          <button onClick={e => { e.stopPropagation(); next(); }}
            style={{ position: 'absolute', right: '24px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', color: '#F0E6D8', borderRadius: '3px', width: '48px', height: '48px', fontSize: '22px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>›</button>

          <button onClick={() => setLightboxIdx(null)}
            style={{ position: 'absolute', top: '20px', right: '20px', background: 'transparent', border: 'none', color: 'rgba(240,230,216,0.5)', fontSize: '24px', cursor: 'pointer' }}>✕</button>

          <div style={{ position: 'absolute', bottom: '20px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '6px' }}>
            {galleryItems.map((_, i) => (
              <button key={i} onClick={e => { e.stopPropagation(); setLightboxIdx(i); }}
                style={{ width: i === lightboxIdx ? '20px' : '6px', height: '3px', background: i === lightboxIdx ? '#C8941A' : 'rgba(255,255,255,0.2)', border: 'none', cursor: 'pointer', borderRadius: '2px', transition: 'all 0.3s', padding: 0 }} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
